import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { combineEventHandlers } from '@hig/utils';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef {import("downshift").DownshiftProps<any>} Props
 * @property {any[]} selectedItems
 */

/**
 * @typedef {Object} GetRemoveButtonPropsOptions
 * @property {function(MouseEvent)} onClick
 * @property {any} item
 */

/**
 * @typedef {import("downshift").ControllerStateAndHelpers<any>} ControllerStateAndHelpers
 * @property {function(GetRemoveButtonPropsOptions): any} getRemoveButtonProps
 * @property {any[]} selectedItems
 */

var MultiDownshift = function (_React$Component) {
  _inherits(MultiDownshift, _React$Component);

  function MultiDownshift() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultiDownshift);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultiDownshift.__proto__ || Object.getPrototypeOf(MultiDownshift)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedItems: _this.getDefaultSelectedItem()
    }, _this.getRemoveButtonProps = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var onClick = _ref2.onClick,
          item = _ref2.item,
          props = _objectWithoutProperties(_ref2, ["onClick", "item"]);

      /**
       * @param {MouseEvent} event
       */
      var handleRemoveButtonClick = function handleRemoveButtonClick(event) {
        event.stopPropagation();
        _this.unselectItem(item);
      };

      var handleClick = combineEventHandlers(onClick, handleRemoveButtonClick);

      return _extends({}, props, {
        onClick: handleClick
      });
    }, _this.stateReducer = function (state, changes) {
      switch (changes.type) {
        case Downshift.stateChangeTypes.clickItem:
          return _extends({}, changes, {
            isOpen: true
          });
        default:
          return changes;
      }
    }, _this.handleSelect = function (selectedItem, downshift) {
      var selectedItems = _this.getSelectedItems();
      var triggerChange = _this.createChangeTrigger(downshift);

      if (selectedItems.includes(selectedItem)) {
        _this.unselectItem(selectedItem, triggerChange);
      } else {
        _this.selectItem(selectedItem, triggerChange);
      }
    }, _this.renderPresenter = function (downshift) {
      return _this.props.children(_this.getStateAndHelpers(downshift));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MultiDownshift, [{
    key: "getDefaultSelectedItem",
    value: function getDefaultSelectedItem() {
      var initialSelectedItems = this.props.initialSelectedItems;


      return initialSelectedItems;
    }

    /**
     * @returns {any[]}
     */

  }, {
    key: "getSelectedItems",
    value: function getSelectedItems() {
      var controlledSelectedItems = this.props.selectedItems;
      var selectedItems = this.state.selectedItems;


      return controlledSelectedItems !== undefined ? controlledSelectedItems : selectedItems;
    }

    /**
     * @param {import("downshift").ControllerStateAndHelpers<any>} downshift
     * @returns {ControllerStateAndHelpers}
     */

  }, {
    key: "getStateAndHelpers",
    value: function getStateAndHelpers(downshift) {
      var selectedItems = this.getSelectedItems();
      var getRemoveButtonProps = this.getRemoveButtonProps;


      return _extends({}, downshift, {
        getRemoveButtonProps: getRemoveButtonProps,
        selectedItems: selectedItems
      });
    }

    /**
     * @param {GetRemoveButtonPropsOptions} options
     * @returns {any}
     */

  }, {
    key: "getDownshiftProps",


    /**
     * @returns {import("downshift").ControllerStateAndHelpers}
     */
    value: function getDownshiftProps() {
      var _props = this.props,
          children = _props.children,
          inputValue = _props.inputValue,
          otherProps = _objectWithoutProperties(_props, ["children", "inputValue"]);

      var controlledInputValue = inputValue !== undefined ? inputValue : this.selectedItemsToString();

      return _extends({}, otherProps, {
        inputValue: controlledInputValue,
        onSelect: this.handleSelect,
        stateReducer: this.stateReducer
      });
    }

    /**
     * @param {import("downshift").DownshiftState<any>} state
     * @param {import("downshift").StateChangeOptions<any>} changes
     * @returns {import("downshift").Partial<StateChangeOptions<any>>}
     */

  }, {
    key: "createChangeTrigger",


    /**
     * @param {import("downshift").ControllerStateAndHelpers} downshift
     */
    value: function createChangeTrigger(downshift) {
      var _this2 = this;

      var multiDownshift = this.getStateAndHelpers(downshift);

      return function () {
        var onChange = _this2.props.onChange;

        var selectedItems = _this2.getSelectedItems();

        if (onChange) {
          onChange(selectedItems, multiDownshift);
        }
      };
    }

    /**
     * @param {any} selectedItem
     * @param {import("downshift").ControllerStateAndHelpers} downshift
     */

  }, {
    key: "selectedItemsToString",


    /**
     * @returns {string}
     * @todo Add intelligent formatting
     */
    value: function selectedItemsToString() {
      var itemToString = this.props.itemToString;

      var selectedItems = this.getSelectedItems();

      return selectedItems.map(itemToString).join(", ");
    }

    /**
     * @param {any} item
     * @param {Function} done
     */

  }, {
    key: "unselectItem",
    value: function unselectItem(item, done) {
      var selectedItems = this.getSelectedItems();
      var nextSelectedItems = selectedItems.filter(function (selectedItem) {
        return selectedItem !== item;
      });

      this.setState({ selectedItems: nextSelectedItems }, done);
    }

    /**
     * @param {any} removedItem
     * @param {Function} done
     */

  }, {
    key: "selectItem",
    value: function selectItem(item, done) {
      var selectedItems = this.getSelectedItems();
      var nextSelectedItems = [].concat(_toConsumableArray(selectedItems), [item]);

      this.setState({ selectedItems: nextSelectedItems }, done);
    }

    /**
     * @param {import("downshift").ControllerStateAndHelpers} downshift
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        Downshift,
        this.getDownshiftProps(),
        this.renderPresenter
      );
    }
  }]);

  return MultiDownshift;
}(React.Component);

MultiDownshift.propTypes = _extends({}, Downshift.propTypes, {
  /** Controlled: the currently selected items */
  selectedItems: PropTypes.arrayOf(PropTypes.any),
  /** Items selected by default */
  initialSelectedItems: PropTypes.arrayOf(PropTypes.any)
});
MultiDownshift.defaultProps = {
  initialSelectedItems: []
};
MultiDownshift.__docgenInfo = {
  "description": "@typedef {import(\"downshift\").ControllerStateAndHelpers<any>} ControllerStateAndHelpers\n@property {function(GetRemoveButtonPropsOptions): any} getRemoveButtonProps\n@property {any[]} selectedItems",
  "displayName": "MultiDownshift",
  "props": {
    "selectedItems": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "any"
        }
      },
      "required": false,
      "description": "Controlled: the currently selected items"
    },
    "initialSelectedItems": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "any"
        }
      },
      "required": false,
      "description": "Items selected by default",
      "defaultValue": {
        "value": "[]",
        "computed": false
      }
    }
  },
  "composes": ["downshift"]
};

export default MultiDownshift;
